import type { Tokens } from '@/types/One';

const ACCESS_KEY = 'nxt-one.access';
const REFRESH_KEY = 'nxt-one.refresh';

// The storage can be unavailable (private window, blocked site data): the session then lives in memory only
const memory: Record<string, string | null> = {};

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return memory[key] ?? null;
  }
}

function write(key: string, value: string | null) {
  memory[key] = value;
  try {
    if (value === null) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, value);
    }
  } catch {
    // Kept in memory
  }
}

export default {
  getAccess(): string | null {
    return read(ACCESS_KEY);
  },
  getRefresh(): string | null {
    return read(REFRESH_KEY);
  },
  setAccess(access: string) {
    write(ACCESS_KEY, access);
  },
  setTokens(tokens: Tokens) {
    write(ACCESS_KEY, tokens.access);
    write(REFRESH_KEY, tokens.refresh);
  },
  clear() {
    write(ACCESS_KEY, null);
    write(REFRESH_KEY, null);
  },
};
